/**
 * Created by m.igrachev on 7/21/2017.
 */
import Validator from "validator";
import validatorLocaleMap from "./validatorLocalesMap";

export default function(toValidate, options) {
    //do not need to check undefined and empty string
    if (!toValidate || toValidate === "") {
        return true;
    }
    let toValidateArray = toValidate.split(" ");
    let locales = options.locales || ["english-uk"];
    let result = false;
    for (let locale of locales) {
        //We search for a locale that toValidate comply to!
        let localeFound = true;
        for (let toValidateToken of toValidateArray) {
            let trueLocale = validatorLocaleMap[locale];
            if (!Validator.isAlpha(toValidateToken, trueLocale)) {
                localeFound = false;
            }
        }
        if (localeFound) {
            result = true;
            break;
        }
    }

    return result;
}
